/* eslint-disable react/jsx-props-no-spreading */
import { Divider, FlexBox, useScreenClass } from '@vp/swan';
import React, { useContext } from 'react';
import { ModTarget } from '@vp/mod-father';
import { LineItemActionsContext } from '../contexts/LineItemActionsContext';
import { ItemEditDesignAndReorderCta } from './reorder/ItemEditDesignAndReorderCta';
import { ItemAddToCartButton } from './reorder/ItemAddToCartButton';
import { LineItemReorderActionFeedback } from './reorder/LineItemReorderActionFeedback';
import { ItemCancelButton } from '../orderdetails/items/ItemCancelButton';
import { ItemEditDesignButton } from './editdesign/ItemEditDesignButton';
import { ItemBuyNowButton } from './reorder/ItemBuyNowButton';
import { DesignFeedbackBanner } from '../orderdetails/designFeedback/DesignFeedbackBanner';

export const LineItemActions = () => {
  const {
    designFeedbackActionEnabled,
    reorderActionEnabled,
    editAndReorderActionEnabled,
    editDesignActionEnabled,
    cancelActionEnabled,
    buyNowActionEnabled,
    isGroupItem,
  } = useContext(LineItemActionsContext);
  const screenClass = useScreenClass();

  const isMobile = ['xs', 'sm'].includes(screenClass);

  const buttonProps = {
    width: isMobile ? 'full-width' : 'standard',
  };

  if (
    !designFeedbackActionEnabled &&
    !reorderActionEnabled &&
    !editAndReorderActionEnabled &&
    !editDesignActionEnabled &&
    !cancelActionEnabled &&
    !buyNowActionEnabled
  ) {
    return null;
  }

  if (designFeedbackActionEnabled) {
    // Here, display banner at item level only for non-group items.
    if (!isGroupItem) {
      return (
        <>
          <Divider my={3} />
          <DesignFeedbackBanner />
          {cancelActionEnabled && <ItemCancelButton {...buttonProps} />}
          <Divider my={3} />
        </>
      );
    }

    if (cancelActionEnabled) {
      return (
        <>
          <Divider my={3} />
          <ItemCancelButton {...buttonProps} />
          <Divider my={3} />
        </>
      );
    }
    return <Divider my={3} />;
  }

  return (
    <>
      <Divider my={3} />
      <FlexBox
        flexWrap="wrap"
        flexDirection={isMobile ? 'column' : 'row'}
        gap="between-actions"
      >
        <ModTarget name="reorderButton">
          {/* currently assume we are on the order history page if we show buy now here */}
          {/* this would work if shown in the details page, but tracking values would be incorrect */}
          {buyNowActionEnabled && (
            <ItemBuyNowButton
              skin="primary"
              style={{ breakAfter: 'always' }}
              {...buttonProps}
            />
          )}
          {reorderActionEnabled && (
            <ItemAddToCartButton
              skin={buyNowActionEnabled ? 'secondary' : 'primary'}
              {...buttonProps}
            />
          )}
          {editAndReorderActionEnabled && (
            <ItemEditDesignAndReorderCta {...buttonProps} />
          )}
        </ModTarget>
        {editDesignActionEnabled && <ItemEditDesignButton {...buttonProps} />}
        {cancelActionEnabled && <ItemCancelButton {...buttonProps} />}
      </FlexBox>
      <LineItemReorderActionFeedback />
      <Divider my={3} />
    </>
  );
};
